<template lang="pug">
#pencil
  .appTools.map
    .level(@click="selectPencilType")
      .type(:title="pencilData.name")
        span 模式：
        img(:src='pencilData.icon' :title='pencilData.name' alt='图标')
        span {{pencilData.name}}
      i.el-icon-arrow-up
    .level(@click="selectSizeData")
      .type(:title="sizeData.label") 笔触：{{sizeData.label}}
      i.el-icon-arrow-up
    .level
      span 颜色 ：
      el-color-picker(v-model="color",popper-class="popperClass",size="mini" @change="startPencil")
    .level
      el-checkbox(v-model="showPencil",size="mini" @change="showOrHidden") 显示画笔
      el-checkbox(v-model="isContinue",size="mini" @change="changeContinue") 连续
    //- .level
    i.el-icon-minus.close(title="最小化",@click="closeAdd")
  transition(name="el-fade-in-linea")
    .pencilType(v-if="typeShow")
      .chil(v-for="item in pencilFuncList" :key="item.query" :class="{'isActive': item.query == pencilData.query}" @click="changeType(item)")
        img(:src="item.icon" :title='item.name' alt='图标')
        span {{item.name}}
  transition(name="el-fade-in-linea")
    .pencilsize(v-if="sizeShow")
      .chil(v-for="item in sizelist" :key="item.value" :class="{'isActive': item.label == sizeData.label}" @click="changeSize(item)")
        span {{item.label}}
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  data () {
    return {
      pencilFuncList: [
        { name: "椭圆", icon: require("./../images/椭圆.png"), query: "ELLIPSE", isActive: false },
        { name: "矩形", icon: require("./../images/矩形.png"), query: "RECT", isActive: false },
        { name: "箭头", icon: require("./../images/箭头.png"), query: "ARROW", isActive: false },
        { name: "引线", icon: require("./../images/引线.png"), query: "LEAD_LINE", isActive: false },
        { name: "文字", icon: require("./../images/文字.png"), query: "TEXT", isActive: false },
        { name: "云线", icon: require("./../images/云线.png"), query: "RECT_CLOUD", isActive: false },
        { name: "手绘线", icon: require("./../images/手绘线.png"), query: "PENCIL", isActive: false },
        { name: "直线", icon: require("./../images/直线.png"), query: "LINE", isActive: false },
        { name: "清空", icon: require("./../images/清空.png"), query: "CLEAR", isActive: false }
      ],
      sizelist: [
        { label: "小", value: "1" },
        { label: "中", value: "3" },
        { label: "大", value: "5" }
      ],
      color: "#ff0000",
      pencilData: {},
      sizeData: {},
      typeShow: false,
      sizeShow: false,
      showPencil: true,
      isContinue: false,

      toolsBoolean: false,
      pencilList: [], // 显示隐藏单一显示,

      sizeColorForm: {
        size: '3',
        color: '#ff0000'
      },
      pencilType: ''
    };
  },
  mounted () {
    this.pencilData = this.pencilFuncList[0];
    this.sizeData = this.sizelist[1];
    this.startPencil();
  },
  methods: {
    selectPencilType() {
      this.typeShow = !this.typeShow;
    },
    changeType(item) {
      if (item.query === "CLEAR") {
        this.$confirm("确定清空画笔？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(async() => {
          mongeApiMlib.clearPencil();
        });
        this.typeShow = false;
        return;
      }
      this.pencilData = item;
      this.typeShow = false;
      this.startPencil();
    },
    changeContinue(val) {
      if (val) {
        this.startPencil();
      } else {
        mongeApiMlib.endPencil();
      }
    },
    selectSizeData() {
      this.sizeShow = !this.sizeShow;
    },
    changeSize(item) {
      this.sizeData = item;
      this.sizeShow = false;
      this.startPencil();
    },
    showOrHidden(val) {
      if (val) {
        mongeApiMlib.showPencilAll();
      } else {
        mongeApiMlib.hiddenPencilAll();
      }
    },
    async startPencil() {
      const colorData = this.color ? "0x" + this.color.substr(1) : "0xFFFFFF";
      let fontSize, lineWidth ;
      if (this.pencilData.query === "TEXT") {
        fontSize = this.selectSize(false);
      } else if (this.pencilData.query === "LEAD_LINE") {
        fontSize = this.selectSize(false);
        lineWidth = this.selectSize(true);
      } else {
        lineWidth = this.selectSize(true);
      }
      await mongeApiMlib.pencil2D(this.pencilData.query, colorData, lineWidth, fontSize, this.isContinue);
    },
    selectSize(isline) {
      let dataSize;
      switch (this.sizeData.value) {
        case "5":
          dataSize = isline ? "5" : "40";
          break;
        case "3":
          dataSize = isline ? "3" : "30";
          break;
        case "1":
          dataSize = isline ? "1" : "20";
          break;
      }
      return dataSize;
    },
    closeAdd() {
      this.$emit("closeCom", 'pencil', true);
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss" ></style>
<style lang="scss" scoped>
.appTools{
  width: 550px;
  left: calc(50% - 275px);
}
.pencilType,.pencilsize{
  position: absolute;
  width: 125px;
  height: 100px;
  overflow-x: hidden;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border-radius: 4px;
  left: calc(50% - 230px);
  bottom: 35px;
  padding: 5px 0;
  z-index: 4;
  .chil{
    padding: 0 14px;
    margin-top: 2px;
    width: 100%;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    img{
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  .chil:hover{
    background: rgba(56, 115, 254, 0.38);
  }
  .isActive{
    background: rgba(56, 115, 254, 0.38);
  }
}
.pencilsize{
  left: calc(50% - 25px);
  width: 60px;
}
// .pencilFunc{
//   position: absolute;
//   bottom: 95px;
//   left: calc(50% - 120px);
//   width: 100px;
//   height: 390px;
//   padding: 5px 0;
//   background: rgba(0, 0, 0, 0.68);
//   box-shadow: 0px 0px 8px 2px rgba(97, 110, 139, 0.78);
//   border-radius: 4px;
//   display: flex;
//   flex-direction: column;
//   z-index: 4;
//   .mList{
//     width: 100%;
//     height: 38px;
//     display: flex;
//     flex-direction: row;
//     align-items: center;
//     color: #fff;
//     cursor: pointer;
//     span{
//       font-size: 14px;
//       line-height: 38px;
//     }
//     .iconRed{
//       width: 4px;
//       height: 4px;
//       border-radius: 4px;
//       margin-left: 5px;
//     }
//     .active{
//       background: #FF0000;
//     }
//     img{
//       margin:  0 5px;
//     }
//   }
//   .isActiveMList{
//     background-color: #fff;
//     background: rgba(56, 115, 254, 0.18);
//   }
//   .mList:hover{
//     background-color: #fff;
//     background: rgba(56, 115, 254, 0.18);
//     // .iconRed{
//     //   background: #FF0000;
//     // }
//   }
// }
// .pencilTools{
//   position: absolute;
//   bottom: 167px;
//   left: calc(50% + 50px);
//   width: 360px;
//   height: 42px;
//   background: rgba(0, 0, 0, 0.68);
//   box-shadow: 0px 0px 8px 2px rgba(97, 110, 139, 0.78);
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
//   align-items: center;
//   padding: 0 10px;
//   /deep/.el-form{
//     margin-top: 8px;
//   }
//   /deep/.el-form-item__label{
//     color: #fff;
//   }
//   /deep/.el-input__inner{
//     background-color: transparent;
//     color: #fff;
//   }
//   /deep/.el-form-item{
//     margin-bottom: 0;
//   }
//   .close{
//     font-size: 16px;
//     color: #fff;
//     cursor: pointer;
//   }
// }
</style>
<style lang="scss">
.popperClass .el-color-dropdown__link-btn{
  display: none;
}
</style>
